
import React from 'react';
import universal from 'react-universal-component';
import { connect } from 'react-redux';
import { string, bool, objectOf, any } from 'prop-types';
import RouteLoadingScreen from 'pages/RouteLoadingScreen';
import RouteErrorScreen from 'components/RouteErrorScreen';
import { selectRoutesMap, selectRouteType } from 'modules/routing';
import { bootDidFinish } from 'state/modules/app';
import { getAttributeRoles } from '../src/helpers/validate';

const RootRoute = ({
  pageComponent,
  isLoading = false,
  currentRoute,
  isAppbarInit
}) => (
  <UniversalComponent
      page={pageComponent}
      isLoading={isLoading}
      currentRoute={currentRoute}
      isAppbarInit={isAppbarInit}
    />
);

RootRoute.propTypes = {
    pageComponent: string.isRequired,
    isLoading: bool,
    currentRoute: objectOf(any).isRequired
};

const UniversalComponent = universal(
    props => import(`pages/${props.page}/index.js`),
    {
        timeout: 60000,
        minDelay: 500,
        chunkName: props => props.page,
        loading: <RouteLoadingScreen/>,
        error: <RouteErrorScreen/>,
        onError: (...error) => console.log(error)
    }
);

export default connect(state => {

  const routesMap = selectRoutesMap(state);
  const routeType = selectRouteType(state);
  const currentRoute = routesMap[routeType];
  const roles = state.app.roles;
  const routeRequiresAuthentication = routesMap[routeType].requiresAuth;
  if(!routeRequiresAuthentication) {
    return {
      currentRoute,
      isLoading: !bootDidFinish(state),
      pageComponent: currentRoute.component
    }
  }
  if (!roles) {
    return {
      currentRoute,
      isLoading: true,
      pageComponent: 'RouteLoadingScreen'
    }
  }
  const hasNoAttributePermission = getAttributeRoles(roles).length === 0;
  const noPermission = hasNoAttributePermission && routeRequiresAuthentication;
  const componentRender = noPermission ? 'NoPermission' : currentRoute.component;
  return {
    currentRoute,
    pageComponent: componentRender,
    // in addition to showing the loading screen as chunks load,
    // we render it until initial app bootup finishes
    isLoading: !bootDidFinish(state),
  };
})(RootRoute);
